import * as React from 'react';
import {Dispatch} from "redux";
import {connect} from "react-redux";

import {RouteComponentProps, withRouter} from "react-router-dom";
import {AppState} from "../store";
import {FeedType, IActiveFeed, IFeed, IFeedState} from "../store/feed/types";
import {hasActiveFeedChanged, selectActiveFeed, selectFeedState} from "../store/feed/selectors";
import FeedSamples from "../components/BannerEditor/FeedSamples";
import {
    deleteFeedAsyncActions,
    IDeleteFeedActionPayload,
    IModifyingActiveFeedActionPayload,
    ISaveFeedAsyncRequestPayload,
    ISelectFeedActionPayload,
    modifyingActiveFeedAction,
    saveFeedAsyncActions,
    setActiveFeedAction
} from "../store/feed/actions";

interface IMatchParams {
}

interface IOwnProps extends RouteComponentProps<IMatchParams> {
}

interface IStateProps {
    feedState: IFeedState;
    activeFeed: IActiveFeed;
    hasActiveFeedChanged: boolean;
}

interface IDispatchProps {
    onSaveFeed: (params: ISaveFeedAsyncRequestPayload) => void;
    onSelectFeed?: (params: ISelectFeedActionPayload) => void;
    modifyingActiveFeed?: (params: IModifyingActiveFeedActionPayload) => void;
    deleteFeed?: (params: IDeleteFeedActionPayload) => void;
}

type IProps = IOwnProps & IStateProps & IDispatchProps;


const mapStateToProps = (state: AppState, props: IOwnProps): IStateProps => ({
    feedState: selectFeedState(state),
    activeFeed: selectActiveFeed(state),
    hasActiveFeedChanged: hasActiveFeedChanged(state),
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {
        onSelectFeed: (params: ISelectFeedActionPayload) => dispatch(setActiveFeedAction(params)),
        onSaveFeed: (params: ISaveFeedAsyncRequestPayload) => dispatch(saveFeedAsyncActions.request(params)),
        modifyingActiveFeed: (params: IModifyingActiveFeedActionPayload) => dispatch(modifyingActiveFeedAction(params)),
        deleteFeed: (params: IDeleteFeedActionPayload) => dispatch(deleteFeedAsyncActions.request(params))
    };
};

class FeedContainer extends React.PureComponent<IProps> {
    componentDidMount(): void {
    }

    onSaveFeed = (feed: IFeed): void => {
        this.props.onSaveFeed({feed: feed, feedType: FeedType.SAMPLE})
    };

    render() {
        // console.log("VariablesContainer render........")
        return (
            <React.Fragment>
                <FeedSamples
                    activeFeed={this.props.activeFeed}
                    feed={this.props.feedState}
                    onSaveFeed={this.onSaveFeed}
                    onSelectFeed={this.props.onSelectFeed}
                    modifyingActiveFeed={this.props.modifyingActiveFeed}
                    hasActiveFeedChanged={this.props.hasActiveFeedChanged}
                    deleteFeed={this.props.deleteFeed}
                />
            </React.Fragment>
        )
    }
}


export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(FeedContainer));


